import { assistantNoticeClasses } from '@/modules/assistant/parts/styles';

export type PanelNoticeProps = {
  /** The sentence the person reads. */
  message: string;
};

/**
 * A failure the person needs to read, above the conversation.
 *
 * `role="alert"` is assertive on purpose, and it is the ONE place in this panel
 * that is: a failed turn means the person asked something and did not get an
 * answer, and an answer that arrives quietly behind their back is worse than an
 * interruption. The conversation log itself is polite — a new answer never talks
 * over the person.
 */
export function PanelNotice({ message }: PanelNoticeProps) {
  return (
    <p role="alert" className={assistantNoticeClasses}>
      {message}
    </p>
  );
}
